import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import CreateExportColumnSpecCommand from "../ExportColumnSpecs/Models/Commands/CreateExportColumnSpecCommand";
import UpdateExportColumnSpecCommand from "../ExportColumnSpecs/Models/Commands/UpdateExportColumnSpecCommand";
import StaticExportColumnSpecLookup from "../ExportColumnSpecs/Models/Lookups/StaticExportColumnSpecLookup";
import StaticExportColumnSpecSearchCriteria from "../ExportColumnSpecs/Models/Queries/StaticExportColumnSpecSearchCriteria";
import StaticExportColumnSpecDropDownLookup from "../ExportColumnSpecs/Models/Lookups/StaticExportColumnSpecDropDownLookup";

export interface IStaticExportColumnSpecApiClient {
    getExportColumnSpecsPagedListAsync(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<StaticExportColumnSpecSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticExportColumnSpecLookup>>>;
    addNewExportColumnSpec(command: Model.PlainObject<CreateExportColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateExportColumnSpec(command: Model.PlainObject<UpdateExportColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class StaticExportColumnSpecApiClient extends Data.ApiClientBase implements IStaticExportColumnSpecApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticExportColumnSpec`)
    }

    public getExportColumnSpecsPagedListAsync(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<StaticExportColumnSpecSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticExportColumnSpecLookup>>> {
        return this.axios.get(`${this.apiPath}/GetExportColumnSpecsPagedList?${Utils.getQueryString(payload)}`);
    }

    public getExportColumnSpecsListAsync(searchCriteria: string, staticExportFileSpecId?: number): AxiosPromise<Array<Model.PlainObject<StaticExportColumnSpecDropDownLookup>>> {
        return this.axios.get(`${this.apiPath}/GetExportColumnSpecList`, { params: { searchCriteria: searchCriteria, staticExportFileSpecId: staticExportFileSpecId }});
    }

    public addNewExportColumnSpec(command: Model.PlainObject<CreateExportColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewExportColumnSpec`, command);
    }

    public updateExportColumnSpec(command: Model.PlainObject<UpdateExportColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateExportColumnSpec`, command);
    }
}